import React, { useState } from "react";
import { HeroSection } from "./components/HeroSection";
import { FeaturesSection } from "./components/FeaturesSection";
import { TokenPacksSection } from "./components/TokenPacksSection";
import { FinalCTASection } from "./components/FinalCTASection";
import CartPage from "./CartPage";
import CheckoutPage from "./CheckoutPage";
import { Modal, Button } from "react-bootstrap";

const LandingPage = () => {
  const [cart, setCart] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [showCart, setShowCart] = useState(false);
  const [showCheckout, setShowCheckout] = useState(false);

  const handleAddToCart = (pack) => {
    setCart([...cart, pack]);
    setShowModal(true);
  };

  const handleRemove = (index) => {
    const newCart = [...cart];
    newCart.splice(index, 1);
    setCart(newCart);
  };

  const handleProceedToCheckout = () => {
    setShowCart(false);
    setShowCheckout(true);
  };

  const handlePaymentSuccess = () => {
    alert("Payment successful!");
    setCart([]);
    setShowCheckout(false);
  };

  return (
    <>
      {!showCart && !showCheckout && (
        <>
          <HeroSection />
          <FeaturesSection />
          <TokenPacksSection onAddToCart={handleAddToCart} />
          <FinalCTASection />
        </>
      )}

      {showCart && (
        <CartPage
          cart={cart}
          onRemove={handleRemove}
          onProceedToCheckout={handleProceedToCheckout}
        />
      )}

      {showCheckout && (
        <CheckoutPage cart={cart} onPaymentSuccess={handlePaymentSuccess} />
      )}

      <Modal show={showModal} onHide={() => setShowModal(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>Added to Cart!</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Your pack has been added to the cart. What would you like to do next?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Continue Browsing
          </Button>
          <Button
            variant="danger"
            style={{ backgroundColor: "#EF3E6D", borderColor: "#EF3E6D" }}
            onClick={() => {
              setShowModal(false);
              setShowCart(true);
            }}
          >
            View Cart
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LandingPage;
